import { render, staticRenderFns } from "./VxEmailInput.vue?vue&type=template&id=58373871"
import script from "./VxEmailInput.vue?vue&type=script&lang=js"
export * from "./VxEmailInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports